
(function(){



    function cocurrences(str, word){
        return str.split(word).length - 1;
    }



    class Coordinates {

        constructor(latitude = 0, longitude = 0, format='DD', locale='en'){

            this.latitude = latitude;
            this.longitude = longitude;
            this.format = format;
            this.locale = locale;
        }

        valid(){

            if(!this.latitude) return false;
            if(!this.longitude) return false;

            if(this.latitude < -90 || this.latitude > 90) return false;
            if(this.longitude < -180 || this.longitude > 180) return false;

            return true;

        }

        formatDMS(){

            if(!this.valid()) return 'Invalid';

            /**
             * Transform from a number to an array with [direction, degrees, minutes, seconds]
             * @param dd number
             */
            function toDMS(dd){

                const d = dd | 0;                 // Degrees (get the integer part)
                const frac = Math.abs(dd-d);      // Get the rest (the fraction part)
                const m = (frac*60) | 0;          // Get the minutes
                const s = (frac*3600 - m*60);     // Get the seconds
                const s2 = Math.round(s*100)/100; // Round the seconds

                return [dd>=0?0:1,Math.abs(d),m,s2];
            }

            const lat = toDMS(this.latitude);
            const lon = toDMS(this.longitude);

            let res = "";

            res += lat[1] + '° ';
            res += lat[2] + "' ";
            res += lat[3] + '" ';
            res += ['N','S'][lat[0]] + " ";


            res += lon[1] + '° ';
            res += lon[2] + "' ";
            res += lon[3] + '" ';
            res += ['E','W'][lon[0]];

            return res;

        }



        static parse(str){

            str = str.toUpperCase();

            if(str.includes('N') || str.includes('S')){

                if(str.includes('W') || str.includes('E')){
                    return this.parseDMS(str);
                }

                if(str.includes('O')){
                    return this.parseDMS(str, 'es');
                }

            }

            return this.parseDD(str);

        }


        static parseDMS(str, locale='en'){

            //
            // Protect the input
            //
            const changes = [
                [/''/g,'"'],
                [/º/g,'°'],
            ];

            if(locale === 'es'){
                changes.push([/O/g,'W']);
                changes.push([/,/g,'.']);
            }

            changes.map(ch => {
                str = str.replace(ch[0], ch[1]);
            });

            //
            // Extra checks
            //
            if(cocurrences(str,'°') !== 2) return new Coordinates();
            if(cocurrences(str,"'") !== 2) return new Coordinates();
            if(cocurrences(str,'"') !== 2) return new Coordinates();


            //
            // Positions
            //
            const pos_d1 = str.indexOf('°');
            const pos_m1 = str.indexOf("'");
            const pos_s1 = str.indexOf('"');

            let ns, ns_sign;
            if(str.includes('N')) {
                ns = 'N';
                ns_sign = +1;
            } else {
                ns = 'S';
                ns_sign = -1;
            }

            const pos_ns = str.indexOf(ns);

            const pos_d2 = str.indexOf('°', pos_ns);
            const pos_m2 = str.indexOf("'", pos_ns);
            const pos_s2 = str.indexOf('"', pos_ns);

            //
            // Retrieve
            //
            const d1 = parseFloat(str.substring(0, pos_d1));
            const m1 = parseFloat(str.substring(pos_d1+1, pos_m1));
            const s1 = parseFloat(str.substring(pos_m1+1, pos_s1));

            const d2 = parseFloat(str.substring(pos_ns+1, pos_d2));
            const m2 = parseFloat(str.substring(pos_d2+1, pos_m2));
            const s2 = parseFloat(str.substring(pos_m2+1, pos_s2));


            let ew_sign;
            if(str.includes('E')) {
                ew_sign = +1;
            } else {
                ew_sign = -1;
            }


            const lat = ns_sign * (d1+(m1/60)+(s1/3600));
            const lon = ew_sign * (d2+(m2/60)+(s2/3600));

            return new Coordinates(lat, lon, 'DMS', locale);


        } // parseDMS


        static parseDD(str){

            let locale = 'en';
            const num_comas = cocurrences(str,',');

            const changes = [];

            if(num_comas === 2){
                locale = 'es';
                changes.push([/,/g,'.']);
            }

            changes.push([/,/g,' ']);
            changes.push([/;/g,' ']);
            changes.push([/\s\s+/g,' ']);

            changes.map(ch => {
                str = str.replace(ch[0], ch[1]);
            });
            str = str.trim();


            const parts = str.split(' ');

            if(parts.length !== 2) return new Coordinates();

            const lat = parseFloat(parts[0]);
            const lon = parseFloat(parts[1]);

            return new Coordinates(lat, lon, 'DD', locale);


        }



    }



    window.ws.coordinates_input = function($input, after=true){

        let value = null;

        // Set the events
        $input.off('focus.coordinates_input');
        $input.off('blur.coordinates_input');
        $input.on('focus.coordinates_input', value_retrieve);
        $input.on('blur.coordinates_input', value_format);

        // Create the hidden
        let $lat = $input.data('latitude_hidden_input');
        let $lon = $input.data('longitude_hidden_input');

        if(!$lat || !$lon){

            $lat = $('<input type="hidden" name="longitude"/>');
            $lon = $('<input type="hidden" name="longitude"/>');

            if(after){
                $lat.insertAfter($input);
                $lon.insertAfter($lat);
            } else {
                $lat.insertBefore($input);
                $lon.insertAfter($lat);
            }


            $input.data('latitude_hidden_input', $lat);
            $input.data('longitude_hidden_input', $lon);
        }


        value_format();


        function value_retrieve(){
            $input.val(value);
        }

        function value_format(){

            // Save the current value
            value = $input.val();

            $lat.val('');
            $lon.val('');

            if(value){
                const coords = Coordinates.parse(value);
                $input.val(coords.formatDMS());

                if(coords.valid()){
                    $lat.val(coords.latitude);
                    $lon.val(coords.longitude);
                }

            } else {
                $input.val('');
            }

        }

        return {
            latitude: $lat,
            longitude: $lon,
        };

    };



    /*

    // 40° 17' 1.3776'' N 7° 1' 52.5'' W (40.283716 -7.031250)
    // 41°39'32.3"N 4°41'50.0"W 41.658970, -4.697212
    const test_coordinates = [

        // eng
        "40° 17' 1.3776'' N 7° 1' 52.5'' W",
        "40.283716 -7.031250",
        "41°39'32.3\"N 4°41'50.0\"W",
        "41.658970, -4.697212",

        // spa
        "40° 17' 1,3776'' N 7° 1' 52,5'' O",
        "40,283716 -7,031250",
        "41°39'32,3\"N 4°41'50,0\"O",
        "41,658970; -4,697212",

    ];

    test_coordinates.map(str => {


        console.log(str);
        const cord = Coordinates.parse(str);
        console.log(cord);
        console.log(cord.valid());
        console.log(cord.formatDMS());
        console.log("-------------");

    });

    */




})(); // End auto-executable anonymous function


